export function validatePromise(
    fn: Function,
    context: any,
    args: any[]
): Promise<[any, Response]> {
    const promise: Promise<[any, Response]> = fn.apply(context, args);
    if (!(promise && typeof promise.then === 'function')) {
        throw new Error(
            'Invalid method for "notification" decorator! The method must return a Promise object.'
        );
    }
    return promise;
}
